import { Tooltip, IconButton } from '@mui/material';
import { BiError } from 'react-icons/bi';
import { IErrorTooltip } from './ErrorTooltip.types';

const ErrorTooltip = (props: IErrorTooltip) => {
  return (
    <Tooltip title={props.message} placement='top'>
      <IconButton size='large'>
        <BiError color='red' size={22} />
      </IconButton>
    </Tooltip>
  );
};
export default ErrorTooltip;
